const breakpoints = {
  width: {
    null: 0,
    xxs: 460,
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1560,
    xxl: 1900,
    xxxl: 2400,
  },
  height: {
    null: 0,
    xxs: 320,
    xs: 420,
    sm: 540,
    md: 660,
    lg: 800,
    xl: 940,
    xxl: 1080,
    xxxl: 1220,
  },
};

/**
 * Return media query up for matched breakpoint
 *
 * @param {String} bp Breakpoint key in `breakpoints` array
 * @param {String} query (width|height) media query target
 */
function breakpointUp(bp, query = 'width') {
  return `only screen and (min-${query}: ${breakpoints[query][bp]}px)`;
}

/**
 * Return media query down for matched breakpoint
 *
 * @param {String} bp Breakpoint key in `breakpoints` array
 * @param {String} query (width|height) media query target
 */
function breakpointDown(bp, query = 'width') {
  return `only screen and (max-${query}: ${breakpoints[query][bp]}px)`;
}

export default { breakpoints, breakpointUp, breakpointDown };



// WEBPACK FOOTER //
// ./scripts/util/breakpoint.js